import { Mutation, MutationTree } from "vuex";
import State from "./state";
import { IMenuModel } from "src/model";

/**
 * 更新SIDEBAR类型
 * @param state 
 * @param type 
 */
export function SET_SIDEBAR_TYPE(state: State, type: boolean): void
{
    state.sidebar = type

    localStorage.setItem("DEFAULT_SIDEBAR_TYPE", type + "");
}

/**
 * 更新色弱模式
 * @param state 
 * @param flag 
 */
export function TOGGLE_WEAK(state: State, flag: boolean): void
{
    state.weak = flag;
    localStorage.setItem("DEFAULT_COLOR_WEAK", flag + "");
}

/**
 * 是否打开tab模式
 * @param state 
 * @param flag 
 */
export function TOGGLE_MULTI_TAB(state: State, flag: boolean): void
{
    state.multiTab = flag
    localStorage.setItem("DEFAULT_MULTI_TAB", flag + "");
}

/**
 * 切换整体风格
 * @param state 
 * @param themeColor 
 */
export function TOGGLE_THEME(state: State, themeColor: string): void
{
    state.theme = themeColor

    if(themeColor)
    {
        localStorage.setItem("DEFAULT_THEME", themeColor);
    }
}

/**
 * 切换导航模式
 * @param state 
 * @param themeColor 
 */
export function TOGGLE_LAYOUT_MODE(state: State, layout: string): void
{
    state.layout = layout

    if(layout)
    {
        localStorage.setItem("DEFAULT_LAYOUT_MODE", layout);
    }
}

/**
 * 切换内容宽度
 * @param state 
 * @param width 
 */
export function TOGGLE_CONTENT_WIDTH(state: State, width: string): void
{
    state.contentWidth = width

    if(width)
    {
        localStorage.setItem("DEFAULT_CONTENT_WIDTH", width);
    }
}

/**
 * 切换颜色
 * @param state 
 * @param width 
 */
export function TOGGLE_COLOR(state: State, color: string): void
{
    state.color = color
    if(color)
    {
        localStorage.setItem("DEFAULT_COLOR", color);
    }
}

/**
 * 是否下滑时隐藏 Header
 * @param state 
 * @param width 
 */
export function TOGGLE_FIXED_HEADER_HIDDEN(state: State, show: boolean): void
{
    state.autoHideHeader = show

    localStorage.setItem("DEFAULT_FIXED_HEADER_HIDDEN", show + "");
}

/**
 * 是否固定头部
 * @param state 
 * @param width 
 */
export function TOGGLE_FIXED_HEADER(state: State, fixedHeader: boolean): void
{
    state.fixedHeader = fixedHeader;
    localStorage.setItem("DEFAULT_FIXED_HEADER", fixedHeader + "");
}

/**
 * 是否固定左侧菜单
 * @param state 
 * @param width 
 */
export function TOGGLE_FIXED_SIDERBAR(state: State, fixed: boolean): void
{
    state.fixSiderbar = fixed

    localStorage.setItem("DEFAULT_FIXED_SIDERBAR", fixed + "");
}

export default <MutationTree<State>>
{
    SET_SIDEBAR_TYPE,
    TOGGLE_WEAK,
    TOGGLE_MULTI_TAB,
    TOGGLE_THEME,
    TOGGLE_LAYOUT_MODE,
    TOGGLE_CONTENT_WIDTH,
    TOGGLE_COLOR,
    TOGGLE_FIXED_HEADER_HIDDEN,
    TOGGLE_FIXED_HEADER,
    TOGGLE_FIXED_SIDERBAR
};
